<template lang="pug">
Button.p-button-outlined(:label="$t('recommendations.resetRecommendations.button')" @click="showPopup")
</template>

<script lang="ts">
import { useRecommendations } from "@/store/recommendations";
import { useSelections } from "@/store/selections";
import { defineComponent } from "vue";
import { storeToRefs } from "pinia";
import Button from "primevue/button";
import { useConfirm } from "primevue/useconfirm";
import { t } from "@/helpers/locale";

export default defineComponent({
  name: "ResetRecommendationsButton",
  components: {
    Button,
  },
  setup() {
    const { resetRecommendations } = useRecommendations();
    const confirm = useConfirm();

    const showPopup = () => {
      confirm.require({
        message: t("recommendations.resetRecommendations.popupContent"),
        header: t("recommendations.resetRecommendations.popupTitle"),
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          resetRecommendations();
        },
      });
    };

    return {
      showPopup,
    };
  },
});
</script>

<style scoped lang="scss">
.p-button {
  width: 100%;
  height: 100%;
}
</style>
